<template>
  <div class="modal dkl-modal-75 fade" :id="objectModalName.system_assessment" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog" role="document">
<!--      <button type="button" class="close xs-close pull-right" @click="closeWarning('#'+objectModalName.system_assessment)" aria-label="Close" data-dismiss="modal"><span aria-hidden="true">&times;</span></button>-->
      <div class="modal-content">
        <div class="modal-header">
          <div class="row w-100">
            <div class="col-md-7 account d-flex">
              <div>
                <h3 class="mb-0">{{ $t('menu.system_assessment') }}
                </h3>
              </div>
            </div>
            <button type="button" class="close xs-close" data-dismiss="modal" @click="closeWarning('#'+objectModalName.system_assessment)">×</button>
          </div>

        </div>

        <div class="modal-body">
          <div class="card">
            <div class="card-body">
              <div class="row center-block">
                <div class="col-md-12">
                  <div class="card mb-0">
                    <div class="card-body">
                      <SurveyComponent
                        refName="assessmentSurvey"
                        :survey-json="surveyJson"
                        :reset-survey="resetSurvey"
                        :surveyID="currentSystemAssessment.survey"
                        :onCompletingCallback="completingCallback"
                        :save-key="saveKey"
                        @surveyCompleted="submitResult"
                        v-if="Object.keys(surveyJson).length>0"
                        :survey-result="surveyResult"
                        @onAfterRenderPage="onSurveyAfterRenderPage"
                        @onValueChanged="onSurveyValueChanged"
                      ></SurveyComponent>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DDKModal
      refName="dsAssessment"
      :title="$t('ds_assessment')"
      v-if="showAssessment"
      width="50%"
      @close ="showAssessment = false">
      <h4 slot="header">Datenschutzrechtliche Bewertung</h4>
      <div slot="body">
        <h5>{{ $t('dpo_assessment') }}</h5>
        <vue-editor v-model="currentSystemAssessment.evaluation"></vue-editor>
        <h5>{{ $t('filled_by') }}</h5>
        <input type="text" class="form-control" name="evaluated_by" v-model="currentSystemAssessment.author">
        <h5 class="mt-2">{{ $t('assessed_by') }}</h5>
        <input type="text" class="form-control" name="evaluated_by" v-model="currentSystemAssessment.evaluated_by">
        <div class="form-group ml-1">
          <input class="form-check-input" type="checkbox" id="approved" name="approved" v-model="currentSystemAssessment.approved" autocomplete="off">
          <label class="form-check-label" for="approved">
            {{ $t('approved') }}
          </label>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-secondary btn-sm" @click="showAssessment=false">Abbrechen</button>
        <button class="btn btn-primary btn-sm" @click="generateAssessmentTable">Bestätigen</button>
      </span>
    </DDKModal>
    <DDKModal
      refName="assessmentConfirmation"
      title="Bitte die Prüfergebnisse bestätigen"
      v-if="showConfirm"
      width="50%"
      @close ="showConfirm = false"
      :before-close="handleClose">
      <h4 slot="header">System Prüfung - {{ accountName }} - {{ reportDate }}</h4>
      <div slot="body">
        <div v-for="(pageObj, pageIndex) in surveyResultsTable" :key="'page_'+pageIndex">
          <div class="row" style="margin: 5px">
            <h5 class="dialogtitle">{{ pageObj.title }}</h5>
          </div>
          <table>
            <tr>
              <td>Prüfpunkte</td>
              <td>Antwort</td>
              <td>Bemerkungen</td>
            </tr>
            <tr v-for="(element, index) in pageObj.elements" :key="index">
              <th>
                <p>
                  {{element.title}}
                </p>
              </th>
              <th>
                <p>
                  {{ element.answer }}
                </p>
              </th>
              <th>
                <p>
                  {{ element.comment }}
                </p>
              </th>
            </tr>
          </table>
          <div><br></div>
        </div>
        <h5>{{ $t('dpo_assessment') }}</h5>
        <vue-editor v-model="currentSystemAssessment.evaluation"></vue-editor>
        <div><br></div>
        <h5>{{ $t('filled_by') }}</h5>
        <p>{{ currentSystemAssessment.author }}</p>
        <h5>{{ $t('assessed_by') }}</h5>
        <p>{{ currentSystemAssessment.evaluated_by }}</p>
        <div class="form-group ml-1">
          <input class="form-check-input" type="checkbox" id="approved" name="approved" v-model="currentSystemAssessment.approved" autocomplete="off">
          <label class="form-check-label" for="approved">
            {{ $t('approved') }}
          </label>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-secondary btn-sm" @click="showConfirm=false">Abbrechen</button>
        <button class="btn btn-primary btn-sm" @click="confirmResult">Bestätigen</button>
<!--        <button class="btn btn-outline-warning btn-sm" @click="confirmResultWithRisk" v-show="showRiskAnalysisBtn">Bestätigen mit Kurzbewertung Risiko</button>-->
      </span>
    </DDKModal>
<!--    <DDKModal-->
<!--      :title="$t('simple_risk_analysis')"-->
<!--      v-if="showSimpleRiskAnalysis"-->
<!--      width="50%"-->
<!--      @close ="showSimpleRiskAnalysis = false">-->
<!--      <h4 slot="header">{{ $t('simple_risk_analysis') }}</h4>-->
<!--      <div slot="body">-->
<!--        <SurveyComponent-->
<!--          refName="simpleRiskAnalysis"-->
<!--          :survey-json="simpleRiskSurvey"-->
<!--          :surveyID="simpleRiskSurveyID"-->
<!--          @surveyCompleted="completeSimpleRiskAnalysis"-->
<!--          v-if="Object.keys(simpleRiskSurvey).length>0"-->
<!--          :survey-result="currentSystemAssessment.risk_analysis_result"-->
<!--          @onAfterRenderPage="onSurveyAfterRenderPageSimpleRisk"-->
<!--          @onValueChanged="onValueChangedSimpleRisk"-->
<!--        ></SurveyComponent>-->
<!--      </div>-->
<!--      <span slot="footer" class="dialog-footer">-->
<!--        <button class="btn btn-secondary btn-sm" @click="showSimpleRiskAnalysis=false">Abschliessen</button>-->
<!--      </span>-->
<!--    </DDKModal>-->
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import {objectModalName, newSystemAssessment, newRiskAnalysis} from "@/utils/enums";
import * as SurveyVue from 'survey-vue'
import {mapState, mapGetters} from 'vuex'
import service from '../../utils/request.js'
import SurveyComponent from '@/components/component/SurveyComponent.vue';
import DDKModal from '@/components/component/Modal'
import {closeWarning, deepCopy, removeHtmlTags} from "@/utils";
import {makeTOMCoverSheet, surveyToExcel} from "@/utils/exportToExcel";

var Survey = SurveyVue.Survey
export default {
  name: 'SystemAssessmentComponent',
  components: {
    Survey,
    DDKModal,
    SurveyComponent,
    VueEditor,
  },
  props: ['currentSystemAssessment', 'surveyJson', 'surveyResult', 'surveyType'],
  data: function() {
    return {
      reportDate: Date.now(),
      showConfirm: false,
      showAssessment: false,
      loading: true,
      completeOption: false,
      surveyConfirmed: false,
      editorData: '', // Initial content
      editorConfig: {
        toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote' ]
      },
      objectModalName: objectModalName,
      surveyResultsTable: [],
      saveKey: `system_assessment_${this.$store.getters.id}_${this.$store.getters.accountid}`,
      saveRiskKey: `simple_risk_analysis_${this.$store.getters.id}_${this.$store.getters.accountid}`,
      // showRiskAnalysisBtn: false,
      simpleRiskSurvey: '',
      simpleRiskSurveyID: null,
      currentRiskAnalysis: newRiskAnalysis,
      showSimpleRiskAnalysis: false,
      generatedReport: '',
      confirmedInstance: null,
      resetSurvey: false,
      currentSurveyResult: null,
      survey: null,
      surveyOptions: null,
    }
  },
  created() {
  },
  beforeDestroy() {
    $(`#${objectModalName.system_assessment}`).off('hidden.bs.modal')
  },
  computed: {
    ...mapGetters(['accountid', 'accountName', 'username', 'id', 'name']),
    ...mapState({customerAddress: state => state.account.address, language: state => state.app.language}),
  },
  mounted() {
    $('#'+objectModalName.system_assessment).on('hidden.bs.modal', () => {
      this.resetSurvey = true
    })
    $('#'+objectModalName.system_assessment).on('shown.bs.modal', () => {
      this.surveyConfirmed = false
    })
  },
  methods: {
    closeWarning,
    // surveyResultLoaded(resultObject) {
    //   if ('question32' in resultObject && resultObject.question32 === 'Item 2') this.showRiskAnalysisBtn = true
    // },
    // completeSimpleRiskAnalysis(result) {
    //   this.currentSystemAssessment.risk_analysis_result = result;
    //   const lang = this.language === 'en' ? 'default' : this.language
    //   const riskResultTable = this.generateResultTable(this.simpleRiskSurvey, result, lang, 'page1')
    //   service.request({
    //     url: `/survey/v1/generate_simple_risk_report/${this.currentSystemAssessment.id}/`,
    //     method: 'POST',
    //     responseType: 'json',
    //     data: {
    //       riskResultTable: riskResultTable,
    //       riskResult: result,
    //       generatedReport: this.generatedReport,
    //     }
    //   }).then((response) => {
    //     this.showSimpleRiskAnalysis = false
    //     this.showAssessment = false
    //     this.generatedReport = decodeURIComponent(response.data.message)
    //     this.confirmedInstance.report_url = this.generatedReport
    //     this.$emit('surveySubmitted', this.confirmedInstance)
    //     console.log('Ausfüllen wurde hochgeladen und Bericht is generiert!')
    //   }).catch((err) => {
    //     console.log(err)
    //   })
    // },
    onSurveyValueChanged(sender, options) {
      this.currentSurveyResult = sender.data
    },
    // onValueChangedSimpleRisk(sender, options) {
    //   this.currentRiskSurveyResult = sender.data
    // },
    submitOnlyResult: function(data, fieldName) {
      const that = this
      let uploadData = {}
      uploadData[fieldName] = data
      service.request({
        url: `/survey/v1/patch_system_assessment/${this.currentSystemAssessment.id}/`,
        method: 'PUT',
        responseType: 'json',
        data: uploadData
      }).then(function(response) {
        that.$emit('currentSystemAssessmentSaved', response.data)
        console.log('Ausfüllen wurde hochgeladen!')
      }).catch(function(err) {
        console.log(err)
      })
    },
    onSurveyAfterRenderPage(sender, options) {
      const container = options.htmlElement.parentElement.querySelector(".sd-footer");
      const button = document.createElement("button");
      if (options.page.name !== 'page1') {
        button.className = "btn-lg sd-btn dkl-red query-save";
        button.innerText = this.language === 'de' ? 'Speichern' : 'Save';
        button.onclick = () => {
          if (this.currentSurveyResult === null) this.$vToastify.info('Keine Änderung vorhanden. Die Speicherung ist nicht notwendig!')
          else this.submitOnlyResult(this.currentSurveyResult, 'result');
        }
        if (container.querySelector('.query-export')) container.querySelector('.query-export').remove();
        if (container.querySelector('.dkl-red') === null) container.appendChild(button)
      } else {
        button.className = "btn-lg sd-btn dkl-red query-export";
        button.innerText = this.language === 'de' ? 'Exportieren' : 'Export';
        button.onclick = () => this.exportSurvey();
        if (container.querySelector('.query-save')) container.querySelector('.query-save').remove();
        if (container.querySelector('.dkl-red') === null) container.appendChild(button);
      }
    },
    // onSurveyAfterRenderPageSimpleRisk(sender, options) {
    //   const container = options.htmlElement.parentElement.querySelector(".sd-footer");
    //   const button = document.createElement("button");
    //   button.className = "btn-lg sd-btn dkl-red";
    //   button.innerText = this.language === 'de' ? 'Speichern' : 'Save';
    //   button.onclick = () => this.submitOnlyResult(this.currentRiskSurveyResult, 'risk_analysis_result');
    //   if (container.querySelector('.dkl-red') === null) container.appendChild(button);
    // },
    // confirmResultWithRisk: async function() {
    //   await this.confirmResult();
    //   this.openSimpleRiskSurvey();
    // },
    // openSimpleRiskSurvey() {
    //   service.get(`survey/v1/survey_by_name/?name=${encodeURIComponent("einfache Risikobewertung")}`).then(response => {
    //     this.simpleRiskSurvey = response.data.body
    //     this.simpleRiskSurveyID = response.data.id
    //     this.showSimpleRiskAnalysis = true
    //   }).catch(error => this.$vToastify.error(String(error)))
    // },
    generateAssessmentTable() {
      if (!this.currentSurveyResult) this.currentSurveyResult = this.currentSystemAssessment.result
      let surveyResult = {}
      try {
        if (typeof this.currentSurveyResult === 'object') {
          JSON.stringify(this.currentSurveyResult)
          surveyResult = this.currentSurveyResult
        } else if (typeof this.currentSurveyResult === 'string') {
          surveyResult = JSON.parse(this.currentSurveyResult)
        }
      } catch (error) {
        console.error("Error processing variable:", error);
      }
      const lang = this.language === 'en' ? 'default' : this.language
      const surveyBody = JSON.parse(this.surveyJson)
      this.surveyResultsTable = this.generateResultTable(surveyBody, surveyResult, lang, 'page2')
      this.currentSystemAssessment.audited_on = (new Date()).toISOString().slice(0, 10)
      this.showConfirm=true
    },
    generateResultTable(surveyBody, surveyResult, lang, startPageName) {
      function getTextAnswerTitle(question, key, lang) {
        const items = question.items
        const item = items.filter(obj => obj.name === key)[0];
        return getAttributeWithFallback(item.title, lang)
      }
      function getChoiceAnswerTitle(question, choice, lang) {
        if (!Array.isArray(choice)) choice = [choice]
        const choices = question.choices
        let answers = []
        choice.forEach(value => {
          if (value === 'other') {
            return 'other'
          } else {
            const item = choices.filter(obj => obj.value === value)[0];
            if (item) answers.push(getAttributeWithFallback(item.text, lang))
          }
        })
        return answers.join(',')
      }
      function processQuestion(question, lang) {
        const questionType = question.type;
        const questionName = question.name;
        const answer = surveyResult[questionName];
        let answerText = ''

        switch (questionType) {
          case 'text':
          case 'comment':
            answerText = answer || 'No Answer';
            break;
          case 'checkbox':
          case 'radiogroup':
            answerText = Array.isArray(answer) ? getChoiceAnswerTitle(question, answer, lang) : getChoiceAnswerTitle(question, [answer], lang) || 'No Answer';
            break;
          case 'multipletext':
            if (answer) {
              answerText = Object.entries(answer).map(([key, value]) => `${getTextAnswerTitle(question, key, lang)}: ${value}`).join(',\n');
            } else {
              answerText = 'No Answer';
            }
            break;
          default:
            answerText = 'Unsupported Question Type';
        }

        if (answerText === 'No Answer' && question.showOtherItem && question.name in surveyResult) {
          answerText = `${getAttributeWithFallback(question.otherText, lang)} ${answer}`
        }
        if (typeof answerText === 'object') answerText = JSON.stringify(answerText);
        answerText = removeHtmlTags(answerText)

        let commentKey = `${questionName}-Comment`

        if (question.showCommentArea && commentKey in surveyResult) {
          answerText = `${answerText} \n Bemerkungen: ${surveyResult[commentKey]}`
        }

        return answerText
      }
      function getAttributeWithFallback(obj, attributeName) {
        // Check if the attribute exists in the object
        if (obj.hasOwnProperty(attributeName)) {
          return removeHtmlTags(obj[attributeName]);
        } else {
          // Fallback to 'de' if the attribute does not exist
          return removeHtmlTags(obj['de']);
        }
      }
      const showRiskPage = 'question32' in surveyResult && surveyResult.question32 === 'Item 3';
      let results = []
      let pages = deepCopy(surveyBody.pages)
      while (pages.length > 0) {
        const element = pages[0]
        if (element.name === startPageName) break;
        pages.shift()
      }
      pages.forEach(page => {
        if (!showRiskPage && page.name === 'page6') {
          return
        }
        let pageObj = {
          title: page.title[lang],
          elements: []
        }

        page.elements.forEach(question => {
          if (question.type === 'panel') {
            question.elements.forEach(element => {
              const elementTitle = getAttributeWithFallback(element.title, lang)
              pageObj.elements.push({
                title: elementTitle,
                answer: processQuestion(element)
              })
            })
          } else if (question.type === 'matrixdropdown') {
            const answer = surveyResult[question.name];
            if (answer) {
              const rows = question.rows
              if (question.transposeData) {
                if (rows.length === 1) {
                  pageObj.elements.push({
                    title: `${getAttributeWithFallback(question.title, lang)}:`,
                    answer: getAttributeWithFallback(rows[0].text, lang),
                    color: 'DDDDDD'
                  })
                  // pageObj.elements.push({
                  //   title: getAttributeWithFallback(rows[0].text, lang),
                  //   answer: ''
                  // })
                  let columnAnswer = answer[rows[0].value]
                  question.columns.forEach((column) => {
                    pageObj.elements.push({
                      title: getAttributeWithFallback(column.title, lang),
                      answer: columnAnswer[column.name]
                    })
                  })
                } else {
                  pageObj.elements.push({
                    title: getAttributeWithFallback(rows[0].text, lang),
                    answer: getAttributeWithFallback(rows[1].text, lang),
                    color: 'DDDDDD'
                  })
                  let columnAnswer1 = answer[rows[0].value]
                  let columnAnswer2 = answer[rows[1].value]
                  let titleValue = ''
                  let answerValue = ''
                  question.columns.forEach((column) => {
                    titleValue = 'no Answer'
                    answerValue = 'no Answer'
                    if (columnAnswer1 && columnAnswer1[column.name]) titleValue = columnAnswer1[column.name]
                    if (columnAnswer2 && columnAnswer2[column.name]) answerValue = columnAnswer2[column.name]
                    if (titleValue !== 'no Answer' || answerValue !== 'no Answer') {
                      pageObj.elements.push({
                        title: titleValue,
                        answer: answerValue
                      })
                    }
                  })
                }
                // Object.entries(answer).forEach(([key, value]) => {
                //   const row = rows.filter(item => item.value === key)[0]
                //   pageObj.elements.push({
                //     title: getAttributeWithFallback(row.text, lang),
                //     answer: Object.values(value).join('\n')
                //   })
                // })
              }
            } else {
              pageObj.elements.push({
                title: getAttributeWithFallback(question.title, lang),
                answer: 'No Answer'
              })
            }
          } else if (question.type !== 'html') {
            const questionTitle = getAttributeWithFallback(question.title, lang)
            pageObj.elements.push({
              title: questionTitle,
              answer: processQuestion(question)
            })
          }
        })
        results.push(pageObj)
      })
      return results
    },
    deleteKeysStartingWith: function (thisKey) {
      // Get the number of keys in localStorage
      const keysToDelete = [];

      // Iterate over each key in localStorage
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);

        // Check if the key starts with the specified string
        if (key.startsWith(thisKey)) {
          keysToDelete.push(key);
        }
      }

      // Remove the keys that start with the specified string
      for (const key of keysToDelete) {
        localStorage.removeItem(key);
      }

      console.log(`All keys starting with "${thisKey}" have been deleted.`);
    },
    confirmResult: async function() {
      this.showConfirm = false;
      this.dialogVisible = false
      this.surveyConfirmed = true
      this.surveyOptions.allowComplete = true
      this.survey.doComplete()
      this.deleteKeysStartingWith(this.saveKey)
    },
    // saveWithoutRisk: async function() {
    //   await this.confirmResult(this.$emit('surveySubmitted', this.confirmedInstance))
    // },
    completingCallback: function(sender, options) {
      const that = this
      if (!that.surveyConfirmed) {
        options.allowComplete = false
        that.resultBody = JSON.stringify(sender.data)
        service.request({
          url: `/survey/v1/patch_system_assessment/${that.currentSystemAssessment.id}/`,
          method: 'PUT',
          responseType: 'json',
          data: {fillout_on: (new Date()).toISOString().slice(0, 10), result: sender.data, survey_type: this.surveyType}
        }).then(function() {
          console.log('Ausfüllen Datum wurde hochgeladen!')
        }).catch(function(err) {
          console.log(err)
        })
        if (!that.currentSystemAssessment.author) that.currentSystemAssessment.author = this.name
        that.currentSystemAssessment.auditor = this.name
        that.currentSystemAssessment.fillout_on = (new Date()).toISOString().slice(0, 10)
        if (that.currentSystemAssessment.is_standard) that.showAssessment = true
        that.survey = sender
        that.surveyOptions = options
        // that.showConfirm = true
      }
    },
    exportSurvey: function () {
      surveyToExcel(JSON.parse(this.surveyJson), this.accountName, 'Systemprüfung')
      const that = this
      service.request({
        url: `survey/v1/survey_by_name/?name=KI Fragebogen`,
        method: 'GET',
        responseType: 'json'
      }).then(function(response) {
        surveyToExcel(response.data.body, that.accountName, 'KI-Prüfung')
      }).catch(function(err) {
        console.log(err)
      })
    },
    submitResult: function() {
      const that = this
      that.currentSystemAssessment.result = that.resultBody
      that.currentSystemAssessment.resultTable = that.surveyResultsTable
      that.currentSystemAssessment.language = that.language
      // Create a FormData object to send the file
      // const formData = new FormData();
      // formData.append('system_assessment', JSON.stringify(that.currentSystemAssessment))
      // const content = that.currentSystemAssessment.evaluation;

      // Convert HTML to a DOCX Blob
      // const converted = htmlDocx.asBlob(content);
      // formData.append('file', converted, 'evaluation.docx');
      service.request({
        url: `/survey/v1/update_generate_report/${that.currentSystemAssessment.id}/`,
        method: 'POST',
        responseType: 'json',
        data: that.currentSystemAssessment
      }).then(function(response) {
        that.$vToastify.success('Ergebnisse erfolgreich hochgeladen. Bericht wird erstellt!')
        that.generatedReport = decodeURIComponent(response.data.link)
        that.confirmedInstance = response.data.instance
        that.showAssessment = false
        that.surveyConfirmed = false
        that.$emit('surveySubmitted', response.data.instance)
      }).catch(function(err) {
        console.log(err)
      })
    },
    handleClose: function(done) {
      done()
    },
  }
}
</script>

<style scoped>
  #surveyContainer {
    font-family: Tahoma, Helvetica, Arial, sans-serif;
    text-align: left;
    font-size: 0.8rem;
  }
  .dkl-red {
    color: #9b3136;
  }
  .questiontitle {
    font-size: 1rem;
  }
  .radio {
    font-size: 0.6rem;
  }
  .sv_q_erbox {
    background-color: red;
    color: red;
  }
  table {
  font-family: 'Tahoma', arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

  td, th {
  text-align: center;
  padding: 8px;
}

  tr:nth-child(even) {
  background-color: #dddddd;
}
  .ired {
    color: red
  }
  .igreen {
    color: green
  }
  h5.dialogtitle {
    color: #7a4c28;
    font-weight: bold;
  }
  .sv_p_root > .sv_row {
    border-bottom: 1px solid #92be05;
  }
  .sv_p_root > .sv_row:nth-child(odd) {
      background-color: white;
    }

  .sv_p_root > .sv_row:nth-child(even) {
    background-color: #ebeef5;
  }
  .sv_p_root > .sv_page_title {
    font-weight: 900;
  }
  .sd-body .sd-body__page {
    margin-left: auto!important;
    margin-right: auto!important;
    max-width: fit-content!important;
  }
  .sd-element .sd-element-yes:hover {
    background-color: rgba(0,255,0,0.4);
  }
  .sd-element .sd-element-no:hover {
    background-color: rgba(255,0,0,0.4);
  }
  .dkl-modal-75 .modal-dialog {
    max-width: 75%!important;
  }
  .close {
    right: 25px;
    top: 20px;
  }
</style>
